<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Beheer</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="customer">
        @if (AuthorisationService.hasAnyFeature(['priceChangeLog', 'pricesSave'])) {
            <div>
                <div class="action" matRipple routerLink="/prices">
                    <i class="fas fa-euro-sign fa-4x"></i>
                    <span>Prijzen beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('decorationSave')) {
            <div>
                <div class="action" matRipple routerLink="/decorations">
                    <i class="fas fa-tools fa-4x"></i>
                    <span>Markeringen beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('customerAreaSave')) {
            <div>
                <div class="action" matRipple routerLink="/customer-areas">
                    <i class="fas fa-draw-polygon fa-4x"></i>
                    <span>Klantgebieden beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('savePbmEquipment')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.ppeEquipment}}">
                    <i class="fas fa-hard-hat fa-4x"></i>
                    <span>PBM beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('saveMoldMaterial')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.moldMaterial}}">
                    <i class="fas fa-do-not-enter fa-4x"></i>
                    <span>Materialen mallen</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('saveSmallMaterial')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.smallMaterial}}">
                    <i class="fas fa-coffee-pot fa-4x"></i>
                    <span>Klein materieel</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('userGet')) {
            <div>
                <div class="action" matRipple routerLink="/users">
                    <i class="fas fa-users fa-4x"></i>
                    <span>Gebruikers beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('extraCostSave')) {
            <div>
                <div class="action" matRipple routerLink="/extra-costs">
                    <i class="fas fa-traffic-light fa-4x"></i>
                    <span>Extra kosten beheren</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('checklistEdit')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.checklists}}">
                    <i class="fas fa-clipboard-check fa-4x"></i>
                    <span>Inspectielijsten beheren</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('declarationManagement')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.declarationTypes}}">
                    <i class="fas fa-file-invoice fa-4x"></i>
                    <span>Declaraties beheren</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('managementDashboard')) {
            <div>
                <div class="action" matRipple routerLink="/dashboard">
                    <i class="fas fa-chart-line fa-4x"></i>
                    <span>Dashboard</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('exportDayProduction')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.dataExport}}">
                    <i class="fas fa-file-excel fa-4x"></i>
                    <span>Export</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('pushpinPartShapefileImport')) {
            <div>
                <div class="action" matRipple routerLink="/pushpin-shape-import">
                    <i class="fas fa-upload fa-4x"></i>
                    <span>Shapefile importeren</span>
                </div>
            </div>
        }
    </div>
</div>
